import { render } from "./ContactEdit.vue?vue&type=template&id=88b96b1e"
import script from "./ContactEdit.vue?vue&type=script&lang=js"
export * from "./ContactEdit.vue?vue&type=script&lang=js"

import "./ContactEdit.vue?vue&type=style&index=0&id=88b96b1e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__